import {Component, inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatFormField, MatHint, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatSelect} from '@angular/material/select';
import {MatOption} from '@angular/material/core';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../../shared/shared.module';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {AdxSbReconciliationFilterService} from '../../service/adx-sb-reconciliation-filter.service';
import {AdxSbReconciliationFilterModel} from '../../model/adx-sb-reconciliation-filter-model';

@Component({
  selector: 'app-adx-sb-filter-modal',
  imports: [
    MatButton,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatFormField,
    MatHint,
    MatInput,
    MatLabel,
    MatSuffix,
    MatSelect,
    MatOption,
    MatSlideToggle,
    ReactiveFormsModule,
    SharedModule,
  ],
  templateUrl: './adx-sb-filter-modal.component.html',
  styles: [`
    .filter__fields {
      display: flex;
      flex-direction: column;
      gap: 4px;
      width: 100%;
      box-sizing: border-box;
    }
    .filter__fields.two-col {
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      gap: 8px 20px;
    }
    mat-form-field {
      width: 100%;
      min-width: 0;
    }
    .filter__toggle {
      display: flex;
      align-items: center;
      padding: 8px 0;
    }
  `],
})
export class AdxSbFilterModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<AdxSbFilterModalComponent>);
  private readonly filterService = inject(AdxSbReconciliationFilterService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  protected readonly form = this.filterService.form;

  protected isSmall = false;

  constructor() {
    this.breakpointObserver.observe([
      Breakpoints.Medium,
      Breakpoints.Small,
      Breakpoints.XSmall,
    ]).subscribe(result => {
      this.isSmall = result.matches;
    });
  }

  public ngOnInit(): void {
    this.patchForm();
  }

  private patchForm(): void {
    const filters = this.filterService.filtersValue();
    this.form.patchValue({
      From: filters.From,
      To: filters.To,
      Day: filters.Day,
      RecordLocator: filters.RecordLocator,
      DateBasis: filters.DateBasis ?? 'Issue',
      OnlyMismatches: filters.OnlyMismatches,
    });
  }

  protected apply(): void {
    const raw = this.form.getRawValue();
    const filters: AdxSbReconciliationFilterModel = {
      From: raw.From,
      To: raw.To,
      Day: raw.Day,
      RecordLocator: raw.RecordLocator,
      DateBasis: raw.DateBasis ?? 'Issue',
      OnlyMismatches: raw.OnlyMismatches,
      ReloadGrid: true,
    };

    this.filterService.setFilters(filters);
    this.close();
  }

  protected reset(): void {
    this.form.reset();
    this.filterService.setFilters({
      ...this.filterService.buildDefaultFilters(),
      ReloadGrid: true,
    });
    this.close();
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
